import React from 'react';
import { CircularProgress, Grid, Typography, Button, Divider, withStyles, Accordion, AccordionDetails, AccordionSummary, makeStyles } from '@material-ui/core';
import { Person as PersonIcon, InfoOutlined, ExpandMore } from '@material-ui/icons';
import styles from './styles';
import PasswordResetDialog from '../PasswordReset/PasswordResetDialog';
import { SuccessToast, CustomInput, CustomPassword, PrimaryButton } from '../../components/common';
import oauthOptions from './oauthOptions';
import selfQueryLogo from '../../img/SelfQueryLogo.png';
import config from '../../utils/config'

const ERROR_LEVEL_COLORS = {
  warning: {
    color: '#856404',
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeeba',
  },
  error: {
    color: '#721c24',
    backgroundColor: '#f8d7da',
    border: '1px solid #f5c6cb',
  },
  success: {
    color: '#155724',
    backgroundColor: '#d4edda',
    border: '1px solid #c3e6cb',
  },
};

const useStyles = makeStyles(theme => ({
  accordionCustom: {
    marginTop: '1rem',
    marginBottom: '1rem',
    borderRadius: '0.5rem',
    boxShadow: 'unset',

    '&::before': {
      display: 'none',
    },
  },
}));

const LoginComponent = ({
  classes,
  data,
  handleChange,
  handleSubmit,
  handleNativeLoginSubmit,
  successMessage,
  passwordResetOpen,
  handlePasswordReset,
  passwordResetSuccess,
  onCloseToast,
  redirectOauth,
}) => {
  const AccordionClass = useStyles();
  return (
  <div className={classes.background}>
    {data.token ? (
      <div className={classes.loadingToken}>
        <CircularProgress size={60} />
        <p style={{ fontSize: 18 }}>Iniciando sesión...</p>
      </div>
    ) : (
      <>
        {data.loading && (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        )}
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justify="center"
          className={classes.gridLogin}
        >
          <form className={classes.formLogin} onSubmit={handleSubmit}>
            <img src={selfQueryLogo} width={140} alt="Logo" style={{ margin: '0 auto' }} />
            <Typography component="h1" variant="h6" className={classes.title} style={{marginBottom: '4rem', fontSize: '24px'}}>
              Documents and Images
            </Typography>
            <Typography component="h1" variant="h5" className={classes.title}>
              Inicio de sesión
            </Typography>
            {data.errorMessage && (
              <div className={classes.errorContainer} style={ERROR_LEVEL_COLORS[data.errorLevel]}>
                <InfoOutlined className={classes.errorIcon} />
                <div className={classes.errorMessage}>
                  {data.errorUuid && <p className={classes.errorUuid}>Código: {data.errorUuid}</p>}
                  <p className={classes.errorText}>
                    {data.errorUuid && 'Detalles:'} {data.errorMessage}
                  </p>
                </div>
              </div>
            )}
            <div>
              {oauthOptions.map(
                ({ label, backgroundColor, icon, endpoint, labelColor = '#FFF' }) => (
                  <Button
                    variant="contained"
                    startIcon={icon}
                    className={classes.oauthButton}
                    style={{ backgroundColor, color: labelColor }}
                    fullWidth
                    onClick={() => redirectOauth(endpoint)}
                  >
                    {label}
                  </Button>
                )
              )}
              <a href={`${config.backEndUrl}entraid/signin`}>
                <Button
                  variant="contained"
                  className={classes.oauthButton}
                  style={{ backgroundColor:'#1E558E', color: '#FFF' }}
                  fullWidth
                >
                  Ingresar via Azure AD
                </Button>
              </a>
            </div>
            <Accordion className={AccordionClass.accordionCustom}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{color: 'rgba(115, 129, 141, 0.62)'}}
              >
                <Typography>Login con usuario y contraseña</Typography>
                
              </AccordionSummary>
              <AccordionDetails style={{flexDirection: 'column'}}>
                <div className={classes.inputLogin} >
                <CustomInput
                  error={data.errorusername}
                  name="username"
                  label="Usuario"
                  type="text"
                  handleChange={handleChange}
                  value={data.username}
                  icon={<PersonIcon className={classes.inputIcon} />}
                />
              </div>
              <div className={classes.inputLogin}>
                <CustomPassword
                  error={data.errorpassword}
                  name="password"
                  placeholder="Contraseña"
                  handleChange={handleChange}
                  value={data.password}
                  variant="outlined"
                />
              </div>
              <PrimaryButton type="submit" className={classes.signInButton} onClick={handleNativeLoginSubmit}>
                Iniciar sesión
              </PrimaryButton>
              </AccordionDetails>
            </Accordion>
            { data.usernameLogin && (
            <>
              <Divider style={{ margin: '20px 0' }} />
              <div className={classes.inputLogin}>
                <CustomInput
                  error={data.errorusername}
                  name="username"
                  label="Usuario"
                  type="text"
                  handleChange={handleChange}
                  value={data.username}
                  icon={<PersonIcon className={classes.inputIcon} />}
                />
              </div>
              <div className={classes.inputLogin}>
                <CustomPassword
                  error={data.errorpassword}
                  name="password"
                  placeholder="Contraseña"
                  handleChange={handleChange}
                  value={data.password}
                  variant="outlined"
                />
              </div>
              <PrimaryButton type="submit" className={classes.signInButton} onClick={handleNativeLoginSubmit}>
                Iniciar sesión
              </PrimaryButton>
            </>
            )}
          </form>
        </Grid>
        <PasswordResetDialog
          open={passwordResetOpen}
          onClose={() => handlePasswordReset(false)}
          onSubmit={passwordResetSuccess}
        />
        <SuccessToast
          open={successMessage !== ''}
          onClose={onCloseToast('successMessage')}
          text={successMessage}
        />
      </>
    )}
  </div>
)};

export default withStyles(styles)(LoginComponent);
